"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      list: [],
      form: {}
    };
  },
  mounted: function mounted() {
    this.setInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    setInfo: function setInfo() {
      var _this = this;
      this.$get('agentapi/system/contract_config', {
        platform_agent_id: this.$route.query.id
      }).then(function (res) {
        _this.list = res;
      });
    },
    /**
     * 提交编辑
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      var params = {};
      if (this.$route.query.id) params.platform_agent_id = this.$route.query.id;
      for (var i in this.list) {
        params[this.list[i].service_id] = this.list[i].service_price;
      }
      this.$post('agentapi/system/contract_config', params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        _this2.$store.dispatch('user/getPlatformConfig');
      });
    }
  }
};